var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"py-2",attrs:{"link":"","to":_vm.item.route,"color":"primary"},nativeOn:{"click":function($event){return _vm.emitEvent(_vm.item)}}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v(_vm._s(_vm.item.icon))])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.item.name))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }